module.exports = "/static-assets/_next/static/images/img-08cc8bd90e-59b64d2c9f1c9097d6a20bae3e7ada00.webp";